"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M18 13h-5.06c-.34 3.1-2.26 5.72-4.94 7.05-.03 1.81-1.66 3.23-3.55 2.9-1.2-.21-2.19-1.2-2.4-2.4C1.71 18.65 3.16 17 5 17c.95 0 1.78.45 2.33 1.14 1.9-1.03 3.26-2.91 3.58-5.14h-3.1c-.48 1.34-1.86 2.24-3.42 1.94-1.18-.23-2.13-1.2-2.35-2.38C1.7 10.66 3.16 9 5 9c1.3 0 2.4.84 2.82 2h3.1c-.32-2.23-1.69-4.1-3.59-5.14-.64.8-1.67 1.28-2.81 1.1-1.23-.19-2.26-1.19-2.47-2.42C1.72 2.65 3.17 1 5 1c1.64 0 2.96 1.31 2.99 2.95 2.68 1.33 4.6 3.95 4.94 7.05H18V9.21c0-.45.54-.67.85-.35l2.79 2.79c.2.2.2.51 0 .71l-2.79 2.79c-.31.31-.85.09-.85-.36z"
}), 'MediationRounded');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/MediationRounded.js
// module id = 7992
// module chunks = 0